import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import { IApiPagination } from "../../../interfaces/IPagination";
import {
  GetProductPriceHistoriesResponse,
  ProductPriceHistoryFilterType,
  TProductPriceHistory,
  TProductPriceHistoryForm,
} from "../types/productPriceHistory.types";
import axiosTeethTab from "../../../services/apiCall";

type ProductPriceHistoryApiInterface = {
  getProductPriceHistories: (
    filter: ProductPriceHistoryFilterType,
    pagination: IApiPagination,
  ) => Promise<ApiResponse<GetProductPriceHistoriesResponse>>;
  saveProductPriceHistory: (
    productPrice: TProductPriceHistoryForm,
  ) => Promise<ApiResponse<TProductPriceHistory>>;
  getProductPriceHistoryById: (
    id: string,
  ) => Promise<ApiResponse<TProductPriceHistory>>;
  enable: (id: string) => Promise<ApiResponse<TProductPriceHistory>>;
  disable: (id: string) => Promise<ApiResponse<TProductPriceHistory>>;
};

const productPriceHistoryApi: ProductPriceHistoryApiInterface = {
  getProductPriceHistories: async (filter, pagination) => {
    const endpoint = "product-price-histories";
    return await axiosTeethTab.get(endpoint, {
      params: {
        filter,
        pagination,
      },
    });
  },
  saveProductPriceHistory: async (productPriceHistory) => {
    const endpoint = productPriceHistory._id
      ? `product-price-histories/${productPriceHistory._id}`
      : "product-price-histories";
    return await axiosTeethTab.post<TProductPriceHistory>(
      endpoint,
      productPriceHistory,
    );
  },
  getProductPriceHistoryById: async (id: string) => {
    const endpoint = `product-price-histories/${id}`;
    return await axiosTeethTab.get<TProductPriceHistory>(endpoint);
  },
  enable: async (id: string) => {
    const endpoint = `product-price-histories/${id}/enable`;
    return await axiosTeethTab.patch<TProductPriceHistory>(endpoint);
  },
  disable: async (id: string) => {
    const endpoint = `product-price-histories/${id}/disable`;
    return await axiosTeethTab.patch<TProductPriceHistory>(endpoint);
  },
};

export default productPriceHistoryApi;
